import { ValidationError } from '~/errors';
import { validateId } from '~/repositories/utils';
import { BaseRestRepository } from './baseRestRepository';
import type {
  CreateLeaseRecurringPaymentDto,
  DeleteLeaseRecurringPaymentDto,
  RecurringLeasePaymentDto,
  RecurringLeasePaymentsDto,
  UpdateLeaseRecurringPaymentDto,
} from '~/swagger/portal/Api';

const LEASES_URL = '/api/leases';

export class LeaseRecurringPaymentRepository extends BaseRestRepository {
  public async getRentPayment(leaseId: string): Promise<RecurringLeasePaymentsDto> {
    const url = `${LEASES_URL}/${leaseId}/charges/recurring-payments`;
    const response = await this.fetchWithAuth(url, {
      method: 'GET',
    });
    return this.getJsonResponse(response);
  }

  public async addRentPayment(leaseId: string, payload: CreateLeaseRecurringPaymentDto): Promise<RecurringLeasePaymentDto> {
    const url = `${LEASES_URL}/${leaseId}/charges/recurring-payments`;
    const response = await this.fetchWithAuth(url, {
      method: 'POST',
      body: JSON.stringify(payload),
    });
    return this.getJsonResponse(response);
  }

  public async updateRentPayment(leaseId: string, recurringPaymentId: string, payload: UpdateLeaseRecurringPaymentDto): Promise<void> {
    validateId(recurringPaymentId);
    if (!recurringPaymentId) throw new ValidationError('RecurringPayment ID must be provided');
    const url = `${LEASES_URL}/${leaseId}/charges/recurring-payments/${recurringPaymentId}`;
    await this.fetchWithAuth(url, {
      method: 'PUT',
      body: JSON.stringify(payload),
    });
  }

  public async deleteRentPayment(
    leaseId: string,
    recurringPaymentId: string,
    deletePostedPayments: DeleteLeaseRecurringPaymentDto
  ): Promise<void> {
    validateId(recurringPaymentId);
    if (!recurringPaymentId) throw new ValidationError('RecurringPayment ID must be provided');
    const url = `${LEASES_URL}/${leaseId}/charges/recurring-payments/${recurringPaymentId}`;
    const response = await this.fetchWithAuth(url, {
      method: 'DELETE',
      body: JSON.stringify(deletePostedPayments),
    });
    if (!response.ok) {
      console.error(await response.json());
    }
  }
}
